import { render, staticRenderFns } from "./zadarmaClickToCall.vue?vue&type=template&id=03b4e52a&lang=pug&"
import script from "./zadarmaClickToCall.vue?vue&type=script&lang=ts&"
export * from "./zadarmaClickToCall.vue?vue&type=script&lang=ts&"
import style0 from "./zadarmaClickToCall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports